import { render } from "./TourFormLondon.vue?vue&type=template&id=24955d1a&scoped=true"
import script from "./TourFormLondon.vue?vue&type=script&lang=js"
export * from "./TourFormLondon.vue?vue&type=script&lang=js"

import "./TourFormLondon.vue?vue&type=style&index=0&id=24955d1a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24955d1a"]])

export default __exports__